import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgOtpInputComponent, NgOtpInputConfig, NgOtpInputModule } from 'ng-otp-input';

@Component({
  selector: 'rx-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgOtpInputModule],
})
export class OtpInputComponent {
  readonly otpLength = 6;
  otp: string;
  @ViewChild(NgOtpInputComponent, { static: false }) ngOtpInput: NgOtpInputComponent;

  config: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: this.otpLength,
  };

  @Output() codeSubmitted = new EventEmitter<string>();

  @Input()
  set error(error) {
    if (error) {
      this.ngOtpInput.setValue('');
    }
  }

  onOtpChange(code): void {
    const submittedValue = code;
    if (submittedValue.length === this.otpLength && this.otp !== code) {
      this.otp = code;
      this.codeSubmitted.emit(submittedValue);
    }
  }
}
